import { client } from '../client';

export interface SubmitNewEmailPayload {
  current_email: string;
  new_email: string;
  frontend_url?: string;
}

export interface SubmitNewEmailResponse {
  message: string;
}

export const submitNewEmail = async (payload: SubmitNewEmailPayload): Promise<SubmitNewEmailResponse> => {
  const { data } = await client.post<SubmitNewEmailResponse>('/auth/email_update/new_email', payload);

  return data;
};
